<template>
  <div class="dropdown-curve-container w-100" @mouseover="openDropdown()">
    <label
      :class="selectedText && selectedText.length > 0 ? 'shift-up' : ''"
      >{{ label }}</label
    >
    <b-dropdown
      variant="dropdown-curve"
      :text="selectedText == null ? '': selectedText"
      class="w-100"
    >
      <div class="px-2 pb-2">
        <input
          required
          autofocus
          type="search"
          :placeholder="`${placeholder}`"
          class="form-control form-control-sm"
          v-model="modeltext"
          v-on:keyup="onInputHandler($event.target.value)"
          v-on:keydown="onInputHandler($event.target.value)"
        />
      </div>
      <b-dropdown-item
        v-for="(item, index) in this.dropdownitemsCopy"
        :key="index"
        :name="`${name}`"
        :id="`${id}`"
        v-on:click="onItemHandler(item)"
        >{{ item[object_value] }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    object_value: {
     type: String,
     default: ""
    },
    type: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    selectedText: {
      type: String,
      default: "",
    },
    dropdownitems: {
      type: Array,
      default: () => [],
    },
    onInput: {
      type: Function,
      default: () => {},
    },
    onHandler: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      modeltext: "",
      dropdownitemsCopy: [],
      selectedvalue: "",
      clicked: true,
    };
  },
  mounted: function() {
    this.dropdownitemsCopy = [...this.dropdownitems];
  },
  methods: {
    openDropdown: function () {
     if(this.clicked) {
        this.dropdownitemsCopy = [...this.dropdownitems];
     }
    },
    onInputHandler: function (value) {
      if (this.modeltext && this.modeltext.length > 0) {
        this.dropdownitemsCopy = this.dropdownitems.filter((x) => {
          if (
            x[this.object_value].toLowerCase().includes(this.modeltext.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.dropdownitemsCopy = [...this.dropdownitems];
      }
    },
    onItemHandler: function (item) {
      console.log(item);
      this.selectedvalue = item[this.object_value];
      this.onHandler(this.type, item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UIElements/DropdownInputSearch.vue